<template>
    <div class="page page-layout administration">
        <div class="form-view page-container">
            <header class="page-header">
                <div class="page-header-background"></div>

                <div class="grid-x" v-show="!loading">
                    <div class="cell auto">
                        <h1 class="page-heading">
                            {{ administrationView !== 'administration-my-userlog' ? 'Indstillinger for' : '' }}
                            <span v-if="administrationView === 'administration-my-profile'">brugeren "{{ userInfo.name }}"</span>
                            <span v-else-if="administrationView === 'administration-my-organisation'">virksomheden "{{ selectedOrganization.name }}"</span>
                            <span v-else-if="administrationView === 'administration-my-companies'">virksomheder</span>
                            <span v-else-if="administrationView === 'administration-my-selectlists'">værdilister</span>
                            <span v-else-if="administrationView === 'administration-my-userinterface'">DRIVE</span>
                            <span v-else-if="administrationView === 'administration-my-userlog'">Log</span>
                        </h1>
                    </div>
                </div>
            </header>

            <main class="page-content" v-show="!loading">
                <left-nav class="side-left-menu" />
                <component :is="administrationView" @open="openModal" />
            </main>
            <div v-show="loading" class="loading-div">
                <h1 class="loading-header">Henter data...</h1>
            </div>
        </div>

        <modal v-if="showModal" :type="modalType" :data="modalData" @close="closeModal" />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import leftNav from './../components/pages/administration/administration-left-nav.vue'
import profile from './../components/pages/administration/administration-profile.vue'
import organisation from './../components/pages/administration/administration-organisation.vue'
import companies from './../components/pages/administration/administration-companies.vue'
import selectlists from './../components/pages/administration/drive/administration-selectlists.vue'
import userinterface from './../components/pages/administration/drive/administration-userinterface.vue'
import userlog from './../components/pages/administration/drive/administration-userlog.vue'
import modal from './../components/shared/modal/modal.vue'

export default {
    name: 'administration',
    data () {
        return {
            showModal: false,
            modalType: null,
            modalData: null,
            loading: false,
            organization: {}
        }
    },
    components: {
        'left-nav': leftNav,
        'administration-my-profile': profile,
        'administration-my-organisation': organisation,
        'administration-my-companies': companies,
        'administration-my-selectlists': selectlists,
        'administration-my-userinterface': userinterface,
        'administration-my-userlog': userlog,
        'modal': modal
    },
    computed: {
        ...mapGetters({
            administrationView: 'getAdministrationView',
            userInfo: 'userInfo',
            selectedOrganization: 'getSelectedOrganization',

            applicationList: 'getApplicationList'
        })
    },
    methods: {
        ...mapActions({
            setAdministrationView: 'setAdministrationView',
            setApplication: 'setApplication',
            setAllCodeLists: 'setAllCodeLists',
            setApplicationSettingsDrive: 'setApplicationSettingsDrive'
        }),
        wait (ms) {
            return (x) => {
                return new Promise(resolve => setTimeout(() => resolve(x), ms))
            }
        },
        closeModal () {
            this.showModal = false
        },
        openModal (view, user) {
            this.modalType = view
            this.modalData = user
            this.showModal = true
        }
    },
    created () {
        // If page gets refreshed for some reason
        if (!this.administrationView) {
            this.setAdministrationView('administration-my-profile')
        }
        if (this.applicationList.filter(app => app.value.toLowerCase() === 'drive').length > 0) {
            new Promise((resolve, reject) => {
                resolve(this.setApplication(this.applicationList.filter(app => app.value.toLowerCase() === 'drive')[0].key))
            }).then(() => {
                this.setAllCodeLists()
                this.setApplicationSettingsDrive()
            })
        }
    }
}
</script>

<style lang="scss">
@import '../scss/components/loader';
@import '../scss/pages/administration';
</style>



// WEBPACK FOOTER //
// src/pages/administration.vue